import { useTranslation } from 'react-i18next';
import { FiArrowLeft } from 'react-icons/fi';
import StudentDetails from './students/StudentDetails';
import StudentCourses from './students/StudentCourses';

export default function StudentPage({ student, onBack }) {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <button
        onClick={onBack}
        className="inline-flex items-center text-sm font-medium text-primary hover:text-primary-dark dark:text-primary-400 dark:hover:text-primary-300"
      >
        <FiArrowLeft className="mr-2 h-4 w-4" />
        {t('backToList')}
      </button>

      <div className="space-y-6">
        <StudentDetails student={student} />
        <StudentCourses courses={student.courses} />
      </div>
    </div>
  );
}